module.exports = __webpack_public_path__ + "static/img/chinalogo.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/chinalogo.png
// module id = w1Wr
// module chunks = 1